import styled from "styled-components"

export const StyledIcon = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: ${(props) => props.size}px;
  min-width: ${(props) => props.size}px;
  max-height: ${(props) => props.size}px;
  min-height: ${(props) => props.size}px;

  & svg {
    width: 100% !important;
    height: 100% !important;
    ${(props) => props.color ? `
        color: ${props.color};
    ` : `
        color: ${props.theme.colors.darkGrey};
    `}
  }
`
